
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ContactForm } from "@/components/contacts/ContactForm";
import { ContactPerson } from "@/lib/types";

interface ContactModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: (contact: ContactPerson) => void;
}

export function ContactModal({ open, onOpenChange, onSuccess }: ContactModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Add New Contact</DialogTitle>
          <DialogDescription>
            Create a new contact that will be available for all contracts.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <ContactForm 
            mode="create"
            onSuccess={(contact) => {
              onSuccess(contact);
              onOpenChange(false);
            }}
            minimal={true}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
